import { ReactNode } from "react";
import css from "@styled-system/css";
import { position, PositionProps, layout, LayoutProps } from "styled-system";
import styled from "styled-components";

import Box from "../Box/Box";
interface OverlayProps extends PositionProps, LayoutProps {
  children: ReactNode;
  css?: string;
}

const StyledDiv = styled(Box)<OverlayProps>`
  box-sizing: border-box;
  ${css({
    boxShadow: 0,
    backgroundColor: "primary-white",
    padding: 1,
    borderRadius: 2,
    fontSize: "body",
    fontFamily: "normal",
    zIndex: 1,
  })}
  ${position}
  ${layout}
  ${(props) => props.css}
`;

export default function OverlayCard({ children, ...props }: OverlayProps) {
  return <StyledDiv {...props}>{children}</StyledDiv>;
}
